export default {
  userId: '',
  userRole: null,
  userFlow: null,
  userFlowHasImages: false,
  userFlowState: null,
  userManageDamageAppointmentFlowResult: null,
  userManageDamageBillmaFlowResult: null
}
